import { useState, useCallback } from 'react';
import {
  Toast,
  ToastProps,
  Banner,
  BannerProps,
} from '@shopify/polaris';

export type IterableBannerProps = Omit<BannerProps, 'children' | 'onDismiss'> & { text: string, onDismiss?: BannerProps['onDismiss'] }
export type IterableToastProps = Omit<ToastProps, 'onDismiss'> & { onDismiss?: ToastProps['onDismiss'] }

export type MessageOptions = {
  messageType: 'toast',
  config: IterableToastProps,
} | {
  messageType: 'banner',
  config: IterableBannerProps,
}

export interface ShowMessage {
  (options: MessageOptions): void;
}

export default function useMessage () {
  const [toastProps, setToastProps] = useState<IterableToastProps | null>(null);
  const [bannerProps, setBannerProps] = useState<IterableBannerProps | null>(null);

  const handleToastDismiss = () => setToastProps(null);
  const handleBannerDismiss = () => setBannerProps(null);

  const showMessage = useCallback(({ messageType, config }: MessageOptions) => {
    if (messageType === "toast") {
      setToastProps({
        ...config,
      });
    }

    if (messageType === "banner") {
      setBannerProps({
        ...config,
      });
    }
  }, []);

  const toastMarkup = toastProps ? (
    <Toast {...toastProps} onDismiss={toastProps.onDismiss || handleToastDismiss}/>
  ) : null;

  const renderBanner = (bannerProps: IterableBannerProps | null) => {
    if (!bannerProps) {
      return null;
    }
    const { text, ...rest } = bannerProps;

    return (
      <Banner {...rest} onDismiss={bannerProps.onDismiss || handleBannerDismiss}>
        <p>{text}</p>
      </Banner>
    );
  };

  const bannerMarkup = renderBanner(bannerProps);

  return { toastMarkup, bannerMarkup, showMessage };
}
